import { useState } from "react";
import { KegFinderApiClient } from "../apiClient";
import { Api as ApiConstants } from "../constants";

export const useApiClient = (): KegFinderApiClient => {
  const [apiClient] = useState(new KegFinderApiClient(ApiConstants.BaseUrl));
  return apiClient;
};